import { ConfigOption } from '@ngx-formly/core';
import { ItemSalesTaxCategoryDropDownComponent } from './controls/item-sales-tax-category-drop-down/item-sales-tax-category-drop-down.component';
import { SalesTaxCategoryDropDownComponent } from './controls/sales-tax-category-drop-down/sales-tax-category-drop-down.component';
import { SalesTaxCodeDropDownComponent } from './controls/sales-tax-code-drop-down copy/sales-tax-code-drop-down.component';

export const TAX_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-item-sales-tax-category-drop-down', component: ItemSalesTaxCategoryDropDownComponent, wrappers: ['simple-title'], },
  { name: 'formly-sales-tax-category-drop-down', component: SalesTaxCategoryDropDownComponent, wrappers: ['simple-title'], },
  { name: 'formly-sales-tax-code-drop-down', component: SalesTaxCodeDropDownComponent, wrappers: ['simple-title'], },
]
